import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/carte-cadeau/page.tsx");
